import { urls } from "../../../urls";

export const v1EventLinkToCurrent = (eventId: string, search: string): string => {
  const params = new URLSearchParams(search);
  const tab = params.get("tab");
  const question = params.get("question");
  const announcement = params.get("announcement");

  if (tab === "qa") {
    return question
      ? urls.app.sourcingEvents.view.question(eventId, question)
      : `${urls.app.sourcingEvents.view.go(eventId)}?tab=communication&sub=questions`;
  }
  if (tab === "announcements") {
    return announcement
      ? urls.app.sourcingEvents.view.announcement(eventId, announcement)
      : `${urls.app.sourcingEvents.view.go(eventId)}?tab=communication&sub=information`;
  }
  return urls.app.sourcingEvents.view.go(eventId);
};
